// The building grid painted onto a sheet picture: the project's lettered and
// numbered lines (api/glance/sheetGrid, page percent) dashed across the page,
// each labelled in a bubble at both ends - an end off the page is pulled to
// its edge along the line. One painter for every 2D place the grid is drawn
// INTO a raster: the markup tool's canvas and the sheet under the model on the
// tracking Model tab (where, painted in, it moves with the plane exactly).
export const GRID_INK = "#2F6FB3";

export function gridPixels(line, w, h) {
  return [line.a, line.b].map((p) => [(Number(p[0]) / 100) * w, (Number(p[1]) / 100) * h]);
}

export function paintSheetGrid(ctx, w, h, lines) {
  if (!ctx || !lines || !lines.length) return;
  const r = Math.max(9, Math.round(Math.min(w, h) / 160));
  ctx.save();
  ctx.strokeStyle = GRID_INK;
  ctx.globalAlpha = 0.8;
  ctx.lineWidth = Math.max(1, r / 9);
  if (ctx.setLineDash) ctx.setLineDash([r, r * 0.7]);
  lines.forEach((l) => {
    const [a, b] = gridPixels(l, w, h);
    ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
  });
  if (ctx.setLineDash) ctx.setLineDash([]);
  ctx.globalAlpha = 1;
  ctx.font = `600 ${Math.round(r * 1.05)}px sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  const clamp = (v, max) => Math.min(max - r - 1, Math.max(r + 1, v));
  lines.forEach((l) => gridPixels(l, w, h).forEach((q) => {
    const x = clamp(q[0], w); const y = clamp(q[1], h);
    ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = "#fff"; ctx.fill(); ctx.stroke();
    ctx.fillStyle = GRID_INK; ctx.fillText(String(l.label), x, y + 0.5);
  }));
  ctx.restore();
}
